import axios from 'axios';
import {
  Container, Grid, Backdrop, CircularProgress, Typography, FormLabel, Button, FormControl,
  Input, InputAdornment, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
  TextField,
} from '@material-ui/core';
import React, { PureComponent } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import '../styles/OrderConfirmComponent.css';
import moment from 'moment';
import { getAPIUrl } from '../helpers/CommonHelper';

class OrderConfirmComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      tip: 0,
      pickupPersonDetails: {},
      dropPersonDetails: {},
      open: false,
      pickupTime: null,
      dropTime: null,
      originalPrice: 0,
      newOfferPrice: 0,
      transaction: '',
    };
  }

  componentDidMount() {
    const query = this.props.location.search.split('=')[1];
    axios.get(`${getAPIUrl()}/order/${query}`, {
      timeout: 30000,
    }).then((response) => {
      this.setState({
        isLoading: false,
        orderId: query,
        ...response.data.data,
      });
    }).catch((error) => {
      alert('Something went wrong!!!');
      console.error(error);
      this.setState({
        isLoading: false,
      });
    });
    document.getElementById('tip-input').setAttribute('maxLength', 3);
  }

  tipHandleChange = (event) => {
    this.setState({
      tip: event.target.value === '' ? 0 : parseInt(event.target.value, 10),
    });
  }

  confirmOrder = () => {
    this.setState({
      open: false,
      isLoading: true,
    });

    axios.put(`${getAPIUrl()}/order/approve/${this.state.orderId}`, {
      newPrice: this.state.newOfferPrice + this.state.tip,
    }, {
      timeout: 30000,
    }).then(() => {
      this.setState({
        isLoading: false,
        transaction: 'SUCCESS',
      });
    }).catch((error) => {
      this.setState({
        isLoading: false,
      });
      if (error.response && error.response.status === 400) {
        alert(error.response.data.message);
      } else {
        console.error(error);
        alert('Something went wrong!!!');
      }
    });
  }

  cancelOrder = () => {
    this.setState({
      open: false,
      isLoading: true,
    });

    axios.put(`${getAPIUrl()}/order/cancel/${this.state.orderId}`, {
      reason: this.state.reason,
    }, {
      timeout: 30000,
    }).then(() => {
      this.setState({
        isLoading: false,
        transaction: 'SUCCESS',
      });
    }).catch((error) => {
      alert('Something went wrong!!!!');
      console.error(error);
      this.setState({
        isLoading: false,
      });
    });
  }

  toggleDialog = () => {
    this.setState({
      open: !this.state.open,
    });
  }

  cancelReasonHandleChange = (event) => {
    this.setState({
      reason: event.target.value,
    });
  }

  redirectTo() {
    if (this.state.transaction === 'SUCCESS') {
      return <Redirect to="/success" />;
    }
    return null;
  }

  render() {
    return (
      <Container className="outer-container">
        {this.redirectTo()}
        <Grid container spacing={3} direction="row" justify="center" alignItems="flex-start">
          <Grid item xs={6} sm={4} md={4}>
            <Typography variant="h6" gutterBottom>
              Pickup details
            </Typography>
            <Typography variant="h6" gutterBottom>
              Address
            </Typography>
            <FormLabel component="legend">
              {this.state.pickupAddress}
            </FormLabel>
            <Typography variant="h6" gutterBottom>
              Time
            </Typography>
            <FormLabel component="legend">
              {this.state.pickupTime && moment(this.state.pickupTime).format('MM-DD-YYYY, h:mm a')}
            </FormLabel>
            <Typography variant="h6" gutterBottom>
              Contact Person
            </Typography>
            <FormLabel component="legend">
              {this.state.pickupPersonDetails.firstName}
              {' '}
              {this.state.pickupPersonDetails.lastName}
            </FormLabel>
            <FormLabel component="legend">
              {this.state.pickupPersonDetails.email}
            </FormLabel>
            <FormLabel component="legend">
              {this.state.pickupPersonDetails.phone}
            </FormLabel>
          </Grid>
          <Grid item xs={6} sm={4} md={4}>
            <Typography variant="h6" gutterBottom>
              Drop details
            </Typography>
            <Typography variant="h6" gutterBottom>
              Address
            </Typography>
            <FormLabel component="legend">
              {this.state.dropAddress}
            </FormLabel>
            <Typography variant="h6" gutterBottom>
              Time
            </Typography>
            <FormLabel component="legend">
              {this.state.dropTime && moment(this.state.dropTime).format('MM-DD-YYYY, h:mm a')}
            </FormLabel>
            <Typography variant="h6" gutterBottom>
              Contact Person
            </Typography>
            <FormLabel component="legend">
              {this.state.dropPersonDetails.firstName}
              {' '}
              {this.state.dropPersonDetails.lastName}
            </FormLabel>
            <FormLabel component="legend">
              {this.state.dropPersonDetails.email}
            </FormLabel>
            <FormLabel component="legend">
              {this.state.dropPersonDetails.phone}
            </FormLabel>
          </Grid>
          <Grid item xs={false} sm={1} md={1} />
          <Grid item xs={12} sm={3} md={3}>
            <Grid container>
              <Grid item xs={8} sm={8} md={8} className="shippingBill">
                <Typography gutterBottom>
                  Previous Shipping Charges
                </Typography>
              </Grid>
              <Grid item xs={4} sm={4} md={4} className="price">
                <FormLabel component="legend">
                  &#36;
                  {' '}
                  {this.state.originalPrice}
                </FormLabel>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={8} sm={8} md={8} className="shippingBill">
                <Typography gutterBottom>
                  New Shipping Charges
                </Typography>
              </Grid>
              <Grid item xs={4} sm={4} md={4} className="price">
                <FormLabel component="legend">
                  &#36;
                  {' '}
                  {this.state.newOfferPrice}
                </FormLabel>
              </Grid>
              <Grid item xs={8} sm={8} md={8} className="shippingBill">
                <Typography gutterBottom>
                  Tip
                </Typography>
              </Grid>
              <Grid item xs={4} sm={4} md={4} className="price">
                <FormLabel component="legend">
                  &#36;
                  {' '}
                  {this.state.tip}
                </FormLabel>
              </Grid>
              <Grid item xs={8} sm={8} md={8} className="shippingBill">
                <Typography gutterBottom>
                  Total
                </Typography>
              </Grid>
              <Grid item xs={4} sm={4} md={4} className="price">
                <FormLabel component="legend">
                  &#36;
                  {' '}
                  {this.state.newOfferPrice + this.state.tip}
                </FormLabel>
              </Grid>
              <br />
              <Grid item xs={8} sm={8} md={8}>
                <Typography gutterBottom>
                  Add a Tip:
                </Typography>
              </Grid>
              <Grid item xs={4} sm={4} md={4}>
                <FormControl fullWidth>
                  <Input
                    id="tip-input"
                    maxLength={3}
                    onChange={this.tipHandleChange}
                    startAdornment={<InputAdornment position="start">$</InputAdornment>}
                  />
                </FormControl>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={12} sm={12} md={12} className="button-margin-top">
                <br />
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => this.confirmOrder()}
                >
                  Accept new price
                </Button>
              </Grid>
              <Grid item xs={12} sm={12} md={12} className="button-margin-top">
                <Button
                  variant="outlined"
                  onClick={() => this.toggleDialog()}
                >
                  Cancel order
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Dialog
          open={this.state.open}
          onClose={this.toggleDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="responsive-dialog-title">Cancel order</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to cancel the order?
            </DialogContentText>
            <TextField
              label="Cancel reason"
              variant="outlined"
              onChange={this.cancelReasonHandleChange}
            />
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={this.toggleDialog} color="primary">
              No
            </Button>
            <Button onClick={this.cancelOrder}>
              Yes
            </Button>
          </DialogActions>
        </Dialog>
        <Backdrop className="loading-indicator" open={this.state.isLoading}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </Container>
    );
  }
}

export default withRouter(OrderConfirmComponent);
